var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-card",
    [
      _c("v-text-field", {
        staticClass: "px-2 text-left",
        attrs: {
          "append-icon": "mdi-magnify",
          label: "ค้นหา",
          "single-line": "",
          "hide-details": "",
        },
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-2",
        attrs: {
          headers: _vm.headers,
          "calculate-widths": "",
          search: _vm.search,
          items: _vm.members,
          "items-per-page": 10,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }